// Datos del equipo. Editá este archivo con la información real.
export const profile = {
  brand: 'Jb_',
  role: 'Desarrollo Fullstack',
  location: 'Salta, Argentina',
  email: 'contacto@portfolio.dev',
  tagline: 'Construimos aplicaciones web de punta a punta: interfaces cuidadas, APIs robustas y bases de datos bien diseñadas.',
  about:
    'Somos un equipo de desarrollo fullstack con foco en productos web escalables. Nos gusta transformar ideas en soluciones concretas, desde el diseño de la interfaz hasta el despliegue en la nube, cuidando la experiencia de usuario, el rendimiento y la calidad del código.',
  // Logos en public/logos. Se muestran en el carrusel de la página de inicio.
  technologies: [
    { name: 'QGIS', logo: 'qgis.svg' },
    { name: 'Python', logo: 'python.svg' },
    { name: 'PostgreSQL', logo: 'postgresql.svg' },
    { name: 'React', logo: 'react.svg' },
    { name: 'JavaScript', logo: 'javascript.svg' },
    { name: 'Node.js', logo: 'nodejs.svg' },
    { name: 'MySQL', logo: 'mysql.svg' },
    { name: 'Git', logo: 'git.svg' },
    { name: 'Docker', logo: 'docker.svg' },
  ],
  services: [
    {
      title: 'Desarrollo web a medida',
      description: 'Aplicaciones web completas, desde el diseño de la interfaz hasta la puesta en producción.',
    },
    {
      title: 'APIs y bases de datos',
      description: 'Diseño de APIs REST, modelado de datos e integración con otros sistemas.',
    },
    {
      title: 'Mapas y datos geográficos',
      description: 'Procesamiento y visualización de información geográfica con QGIS, Python y PostgreSQL.',
    },
    {
      title: 'Asesoría técnica',
      description: 'Revisión de arquitectura y código, y ayuda para elegir tecnologías.',
    },
  ],
  experience: [
    {
      period: '2025 — Actualidad',
      title: 'Desarrollo Fullstack',
      company: 'Proyectos freelance',
      description: 'Desarrollamos aplicaciones web a medida para clientes: e-commerce, paneles de gestión y APIs.',
    },
    {
      period: '2024 — 2025',
      title: 'Desarrollo Frontend',
      company: 'Estudio de software',
      description: 'Maquetamos interfaces responsivas en React y las conectamos con APIs REST.',
    },
    {
      period: '2023 — Actualidad',
      title: 'Ingeniería en Sistemas',
      company: 'Universidad',
      description: 'Nos formamos en programación, bases de datos, arquitectura de software y metodologías ágiles.',
    },
  ],
};
